import React from 'react'

const ExpandIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path className='custom-icon-stroke' d="M8 4H4V8M4.5 4.5L9 9M16 4H20V8M19.5 4.5L15 9M8 20H4V16M4.5 19.5L9 15M16 20H20V16M19.5 19.5L15 15" stroke="#484646" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export default ExpandIcon
